<template>
  <div
    v-if="loading"
    class="d-flex justify-center"
  >
    <div class="d-flex align-center">
      <v-progress-circular
        indeterminate
        size="20"
        width="2"
        color="primary"
        class="mr-2"
      />
      <p>Searching...</p>
    </div>
  </div>
  <div v-if="files.length > 0">
    <p class="text-center text-secondary font-weight-bold">
      {{ files.length }} file(s) found:
    </p>
    <div
      v-for="(file, index) in files"
      :key="index"
      class="my-2 pl-4"
    >
      <div
        class="d-inline-flex align-center cursor-pointer"
        @click="navigate(file.folder_id, file.name)"
      >
        <div>
          <v-img
            :src="file_icon(file)"
            class="my-4"
            height="30"
            width="30"
          />
        </div>
        <div class="d-flex flex-column ml-2">
          <p style="font-size: 16px">
            {{ file_name(file.name) }}
          </p>
          <p style="font-size: 12px">
            {{ file.size_formatted }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="empty"
  >
    <p class="text-center">
      No results found.
    </p>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import icons from "@/plugins/icons"
import debounce from "lodash/debounce"

export default defineComponent({
  mixins: [icons],
  props: {
    search: {
      type: String,
      required: true,
    },
  },
  emits: ['clear'],
  data() {
    return {
      files: [] as App.Models.File[],
      empty: false as boolean,
      loading: false as boolean,
      debounce: null as null | ((value: string) => void),
    }
  },
  watch: {
    search: {
      immediate: true,
      handler(value: string) {
        this.loading = true

        this.debounce?.(value)
      },
    }
  },
  mounted() {
    if (this.search.trim() !== '') {
      this.empty = false

      this.loading = true

      this.debounce?.(this.search)
    }
  },
  created() {
    this.debounce = debounce(async (value: string) => {
      if (value.trim() === '') {
        this.files = []

        return
      }

      const { data } = await this.$http.get(`/files`, {
        params: {
          search: value,
          itemsPerPage: 100,
        }
      })

      this.files = data.data as App.Models.File[]

      this.empty = this.files.length === 0

      this.loading = false
    }, 500)
  },
  methods: {
    async navigate(folder: number, file: string) {
      await this.$router.push({
        name: this.ROUTES.FILES,
        params: { folderId: folder.toString() },
        query: { file }
      })

      this.$emit('clear')
    },
    file_name(name: string) {
      return name.length > 20 ? name.slice(0, 20) + '...' : name
    },
  }
})
</script>
